"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var cardsDefaults = {
  // All cards
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
  contentBgColor: 'white',
  profileCardContentBgColor: 'white',
  contentTextColor: 'inherit',
  copyTextSize: 'medium',
  imageOverlay: 'rgba(0, 0, 0, 0.2)',
  labelColor: 'secondary',
  titleColor: 'black',
  titleTextSize: 'small',
  titleUnderline: '2px',
  labelTextSize: 'small',
  featuredCardLabelTextSize: 'medium',
  fontFamily: null,
  cardBadgeTextSize: 'xsmall',
  cardBadgeBgColor: 'offwhite',
  cardBadgeColor: 'offblack',
  cardBadgeTextTopIE: null,
  cardGradient: 'linear-gradient(rgba(255, 255, 255, 0) 48%, rgb(255 255 255))',
  // Product
  primaryCtaProductCard: 'primary',
  secondaryCtaProductCard: 'secondary',
  priceTextWeight: 'normal',
  currentPriceSize: 'xlarge',
  previousPriceSize: 'medium',
  // Signpost
  borderRadius: '4px',
  borderTop: '10px solid',
  borderTopColor: 'greydark',
  textDecoHover: 'underline',
  textDecoHoverSignPost: 'underline',
  textOnlyBorder: 'inherit',
  textOnlyBorderColor: 'inherit',
  heightWithImgTablet: '8rem',
  heightNoImgTablet: '8rem',
  heightNoImgDesktop: '8rem',
  heightNoImgWide: '11rem',
  backgroundColor: 'unset',
  hoverBackgroundColor: 'unset',
  paddingTopBottom: 'unset',
  bodyTextColor: 'unset',
  titleIcon: '',
  contentFlexWrap: 'unset',
  // List
  listHeightTablet: '29rem',
  listHeight: '25rem',
  cardListLabelBgColor: 'offwhite',
  cardListLabelColor: 'offblack'
};
var cards = {
  horizon: _objectSpread(_objectSpread({}, cardsDefaults), {}, {
    contentTextColor: 'black',
    heightWithImgTablet: '12rem'
  }),
  lionsLive: _objectSpread(_objectSpread({}, cardsDefaults), {}, {
    contentBgColor: 'black',
    contentTextColor: 'white',
    imageOverlay: 'transparent',
    titleColor: 'white',
    // Product
    primaryCtaProductCard: 'secondary',
    secondaryCtaProductCard: 'secondary',
    // Signpost
    borderTopColor: 'none'
  }),
  money2020: _objectSpread(_objectSpread({}, cardsDefaults), {}, {
    imageOverlay: 'transparent',
    // Signpost
    borderTopColor: 'black'
  }),
  dcl: _objectSpread(_objectSpread({}, cardsDefaults), {}, {
    contentBgColor: 'white',
    contentTextColor: 'black',
    boxShadow: 'none',
    imageOverlay: 'transparent',
    labelColor: 'primary',
    // List
    listHeightTablet: '29rem',
    listHeight: '28rem'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, cardsDefaults), {}, {
    boxShadow: 'none',
    contentBgColor: 'secondary',
    contentTextColor: 'offblack',
    copyTextSize: 'xsmall',
    imageOverlay: 'transparent',
    labelColor: 'offblack',
    titleColor: 'primary',
    titleTextSize: 'xxsmall',
    titleUnderline: 'none',
    labelTextSize: 'xsmall',
    fontFamily: 'Riviera Nights Regular',
    cardBadgeTextTopIE: '4px',
    cardGradient: 'linear-gradient(rgba(243, 244, 245, 0) 48%, rgb(243 244 245))',
    // Product
    currentPriceSize: 'medium',
    previousPriceSize: 'small',
    priceTextWeight: 'bold',
    // Signpost
    borderRadius: '0',
    borderTop: '1px solid',
    borderTopColor: 'transparent',
    textDecoHover: 'none',
    textDecoHoverSignPost: 'none',
    textOnlyBorder: '1px solid',
    textOnlyBorderColor: 'primary',
    heightNoImgTablet: '19rem',
    heightNoImgDesktop: '18rem',
    heightNoImgWide: '18rem',
    backgroundColor: 'rgb(187,205,216)',
    hoverBackgroundColor: 'rgb(215,176,125)',
    paddingTopBottom: 'xlarge',
    paddingLeftRight: 'large',
    bodyTextColor: 'rgb(46, 46, 46)',
    titleIcon: 'ChevronRight',
    contentFlexWrap: 'wrap',
    // CardList
    cardListLabelColor: 'primary'
  })
};
var _default = cards;
exports.default = _default;